// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import RouteBuilder from '@Services/RouteBuilder';
import { CardContentProps } from '../CardContentType';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';

export const ProcedureContent = ({ data, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();

    const { pattern, case: dataCase, alert: dataAlert, _id } = data || {};
    const { context } = base;

    const parent = dataAlert || dataCase || context;
    const parentType = parent?._type.toLocaleLowerCase();

    const rootPath =
        parentType === 'alert'
            ? RouteBuilder.compute('alerts.procedures', { alertId: parent?._id })
            : parentType === 'case'
            ? RouteBuilder.compute('cases.procedures', { caseId: parent?._id })
            : null;

    const customDetails = {
        description: pattern?.description,
    };

    const title = `${pattern?.patternId} - ${pattern?.name}`;

    return (
        <StreamCard
            icon={<ICONS.TTPIcon />}
            title={pattern?.name ? title : local('stream.card.procedure.delete')}
            path={rootPath}
            base={base}
            parent={parent}
        >
            {Object.entries(customDetails).map(([key, value]) => (
                <PropRender key={_id + key} prop={key} value={value} type="procedure" />
            ))}
        </StreamCard>
    );
};
